export default __webpack_public_path__ + "static/media/teams.87c21a5a.png";